export default "__VITE_ASSET__DtwICiD7__"